/**
 * Common - Log module
 */

// Imports
import {
  isEmpty,
} from './Utils';

/**
 * Logs a message.
 *
 * @param {String} asMessage - The message to be logged.
 */
function logMessage(asMessage) {
  if (window.console && console.log) {
    console.log(asMessage);
  }
}

/**
 * Logs a "info" message.
 *
 * @param {String} asMessage - The message to be logged.
 */
function logInfo(asMessage) {
  if (window.console && console.info) {
    console.info(asMessage);
  }
}

/**
 * Logs a "error" message.
 *
 * @param {String} asMessage - The message to be logged.
 */
function logError(asMessage) {
  if (window.console && console.error) {
    console.error(asMessage);
  }
}

function log(asMessage, asType) {
  if (isEmpty(asType)) {
    logMessage(asMessage);

    return;
  }

  switch (asType) {
    case 'info':
      logInfo(asMessage);

      break;
    case 'error':
      logError(asMessage);

      break;
    default:
      logMessage(asMessage);

      break;
  }
}

// Named exports
export {
  log,
  logMessage,
  logInfo,
  logError,
};



// WEBPACK FOOTER //
// ./js/common/Log.js